import { getServiceTerminalIdBackendPath, setupRequestEditBackendPath } from "routes/e_payment";

export const E_PAYMENT_UPDATE_SETUP_REQUEST = 'E_PAYMENT_UPDATE_SETUP_REQUEST';
export const E_PAYMENT_UPDATE_SETUP_REQUEST_LOADING = 'E_PAYMENT_UPDATE_SETUP_REQUEST_LOADING';
export const E_PAYMENT_UPDATE_SETUP_REQUEST_SUCCESS = 'E_PAYMENT_UPDATE_SETUP_REQUEST_SUCCESS';
export const E_PAYMENT_UPDATE_SETUP_REQUEST_FAILURE = 'E_PAYMENT_UPDATE_SETUP_REQUEST_FAILURE';

export const E_PAYMENT_GET_SERVICE_TERMINAL_ID = 'E_PAYMENT_GET_SERVICE_TERMINAL_ID';
export const E_PAYMENT_GET_SERVICE_TERMINAL_ID_LOADING = 'E_PAYMENT_GET_SERVICE_TERMINAL_ID_LOADING';
export const E_PAYMENT_GET_SERVICE_TERMINAL_ID_SUCCESS = 'E_PAYMENT_GET_SERVICE_TERMINAL_ID_SUCCESS';
export const E_PAYMENT_GET_SERVICE_TERMINAL_ID_FAILURE = 'E_PAYMENT_GET_SERVICE_TERMINAL_ID_FAILURE';


export const updateSetupRequest = (data, cancelPrevious = true) => ({
  type: E_PAYMENT_UPDATE_SETUP_REQUEST,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: setupRequestEditBackendPath, cancelPrevious }
});

export const getEpaymentServiceTerminalId = (shop_id, cancelPrevious = true) => ({
  type: E_PAYMENT_GET_SERVICE_TERMINAL_ID,
  payload: { shop_id: shop_id },
  meta: { httpMethod: 'GET', apiPath: getServiceTerminalIdBackendPath, cancelPrevious }
});



// WEBPACK FOOTER //
// ./src/actions/e_payment/index.js